import { size as _size } from 'lodash-es';
import { dbUserSessions } from 'dbServer/collections';
import { USER_SESSION_STATUS } from 'store/constants';

export const hasUserAlreadyRegisteredToSession = async sessionId => {
	const exists = await dbUserSessions.getUserSession(sessionId);
	return !!exists;
};

export const fetchUserSessions = async () => {
	const userRegisteredSessions = await dbUserSessions.getUserSessions();
	return !_size(userRegisteredSessions) ? [] : userRegisteredSessions;
};

export const registerUserToSession = async sessionId => {
	const userRegisteredSession = await dbUserSessions.registerUserToSession(sessionId, {
		status: USER_SESSION_STATUS.REGISTERED,
		registeredDate: new Date().toUTCString()
	});
	return !_size(userRegisteredSession) ? [] : userRegisteredSession;
};

export const unregisterUserToSession = async sessionId => {
	const unregisteredUserSession = await dbUserSessions.updateUserSession(sessionId, {
		status: USER_SESSION_STATUS.CANCELLED,
		cancelledDate: new Date().toUTCString()
	});
	return !_size(unregisteredUserSession) ? [] : unregisteredUserSession;
};

export const addUserSessionFeedback = async (sessionId, feedback) => {
	const userSessionFeedback = await dbUserSessions.updateUserSessionFeedback(sessionId, {
		...feedback,
		feedbackDate: new Date().toUTCString()
	});
	return !_size(userSessionFeedback) ? {} : userSessionFeedback;
};
